export default __webpack_public_path__ + "a04d0c434415b8b3e335c760136f98b8.jpg";